import { highchartThemeDark } from '@/utils/highchart-theme-dark';
import { generateRandomId } from '@/utils/math';
import { EXTENSION_TYPES } from '@/utils/constants';
import { trackEventWithUserProperties } from '@/utils/mixpanel';
import { HEIGHT } from '@/store/modules/cards/constants';
import * as Sentry from '@sentry/browser';

const MAX_ITEM = {
  [HEIGHT.SMALL]: 5,
  [HEIGHT.MID]: 13,
  [HEIGHT.LARGE]: 22,
  [HEIGHT.XLARGE]: 38,
};

const MAX_ITEM_EXCEPTION = {
  [HEIGHT.SMALL]: 1,
  [HEIGHT.MID]: 3,
  [HEIGHT.LARGE]: 5,
  [HEIGHT.XLARGE]: 10,
};

const EXCEPTION = 'VariationOfFanBaseChart';

export default {
  computed: {
    highchartsBasics() {
      return {
        chart: {
          backgroundColor: 'transparent',
          style: {
            overflow: '',
            'font-family': 'Open Sans',
          },
        },
        title: {
          text: '',
          style: {
            fontSize: '1px',
            color: 'transparent',
          },
          y: -50,
        },
        exporting: {
          enabled: false,
          filename: this.title,
        },
        theme: {
          fill: '#ababab',
          r: 5,
          'font-size': '12px',
          'font-weight': 'bold',
          style: {
            'font-family': 'Open Sans',
            color: 'white',
          },
          stroke: '#ababab',
          states: {
            hover: {
              fill: '#ababab',
              color: 'white',
              stroke: '#ababab',
            },
          },
        },
        time: {
          useUTC: false,
        },
        credits: false,
      };
    },
    highchartTheme() {
      if (this.$vuetify.theme.dark) {
        return highchartThemeDark;
      }
      return {};
    },
    chartRef() {
      return `chart-${generateRandomId()}`;
    },
    highchartExportItems() {
      return [
        {
          action: () => this.exportChart(() => {
            this.$refs[this.chartRef].chart.exportChart({ type: EXTENSION_TYPES.PNG.mimeType });
          }),
          title: this.$t('mixins.highchartsBasics.label.message', { type: EXTENSION_TYPES.PNG.name }),
          type: EXTENSION_TYPES.PNG.name,
        },
        {
          action: () => this.exportChart(() => {
            this.$refs[this.chartRef].chart.downloadCSV();
          }),
          title: this.$t('mixins.highchartsBasics.label.message', { type: EXTENSION_TYPES.CSV.name }),
          type: EXTENSION_TYPES.CSV.name,
        },
      ];
    },
    maxItemsToBeDisplayed() {
      const maxItems = this.card.component === EXCEPTION ? MAX_ITEM_EXCEPTION : MAX_ITEM;

      if (!this.card?.height) {
        return maxItems[HEIGHT.MID];
      }

      return maxItems[this.card.height];
    },
  },
  methods: {
    exportChart(successCallback) {
      if (!this.$refs[this.chartRef]) {
        console.error('The chart must have a reference to find highcharts instance, please add :ref="chartRef" to your chart tag.');
        Sentry.captureException(new Error(`Failed to export "${this.title}"`));
        return false;
      }
      successCallback();
    },
    exportHighchartComponent(component) {
      component.action();

      trackEventWithUserProperties('ST Card Options Export', { Type: component.type });
    },
    exportComponentCSV() {
      if (!this.$refs[this.chartRef]) {
        console.error('The chart must have a reference to find highcharts instance, please add :ref="chartRef" to your chart tag.');
        Sentry.captureException(new Error(`Failed to export "${this.title}"`));
        return false;
      }
      this.$refs[this.chartRef].chart.downloadCSV();
      trackEventWithUserProperties('ST Card Options Export', {
        type: EXTENSION_TYPES.CSV.name,
        title: this.card?.props?.title,
        widget: this.card?.component,
      });
    },
  },
};
